import React, { useState, useEffect } from "react";
import convert_button from "../assets/images/convert_button.svg";
import cb from "../assets/images/c_b2.png";
const ResponsiveFormatsSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [animateButtons, setAnimateButtons] = useState(false);

  useEffect(() => {
    // Trigger animations on mount
    const timer1 = setTimeout(() => setIsVisible(true), 300);
    const timer2 = setTimeout(() => setAnimateButtons(true), 800);

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
    };
  }, []);

  const formatButtons = [
    { row: 1, formats: ["PNG", "JPEG"] },
    { row: 2, formats: ["JPG", "SVG", "convert_button", "WEBP", "TIFF"] },
    { row: 3, formats: ["PDF", "AVIF"] },
  ];

  return (
    <section className="hari_class w-full bg-gradient-to-br from-green-600 via-green-500 to-green-700 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `radial-gradient(circle at 25% 25%, rgba(255,255,255,0.1) 1px, transparent 1px)`,
            backgroundSize: "40px 40px",
          }}
        ></div>
      </div>

      <div className="relative z-10 container mx-auto py-12 sm:py-16 lg:py-20 size-decre">
        {/* Title Animation */}
        <div
          className={`text-center mb-8 sm:mb-12 lg:mb-16 transition-all duration-1000 transform ${
            isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"
          }`}
        >
          <h2 className="text-white text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-bold mb-4 relative">
            All Formats Supported
            <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 w-16 sm:w-20 lg:w-24 h-1 bg-white rounded-full opacity-70"></div>
          </h2>
          <p className="text-white/80 text-sm sm:text-base lg:text-lg max-w-2xl mx-auto mt-6">
            Convert between multiple file formats with ease and precision
          </p>
        </div>

        {/* Animated Format Buttons */}
        <div className="max-w-5xl mx-auto">
          {formatButtons.map((row, rowIndex) => (
            <div
              key={rowIndex}
              className={`
                green
                flex justify-center items-center flex-wrap gap-2 sm:gap-3 md:gap-4 lg:gap-6 xl:gap=[1rem]
                mb-4 sm:mb-6 lg:mb-8
                transition-all duration-1000 transform
                ${
                  animateButtons
                    ? "translate-y-0 opacity-100"
                    : "translate-y-8 opacity-0"
                }
                ${
                  rowIndex === 1
                    ? "px-2 sm:px-4 md:px-8 lg:px-16"
                    : "px-2 sm:px-4"
                }
              `}
              style={{ transitionDelay: `${rowIndex * 200 + 400}ms` }}
            >
              {row.formats.map((format, buttonIndex) => (
                <AnimatedButton
                  key={format}
                  format={format}
                  delay={rowIndex * 200 + buttonIndex * 100 + 600}
                  isConvertImage={format === "convert_button"}
                />
              ))}
            </div>
          ))}
        </div>

        {/* Decorative Elements */}
        <div className="absolute top-10 left-4 sm:left-10 w-3 h-3 sm:w-4 sm:h-4 bg-white opacity-20 rounded-full animate-pulse"></div>
        <div
          className="absolute bottom-10 right-4 sm:right-10 w-4 h-4 sm:w-6 sm:h-6 bg-white opacity-10 rounded-full animate-bounce"
          style={{ animationDelay: "1s" }}
        ></div>
        <div
          className="absolute top-1/2 left-2 sm:left-5 w-2 h-2 sm:w-3 sm:h-3 bg-white opacity-15 rounded-full animate-ping"
          style={{ animationDelay: "2s" }}
        ></div>
        <div
          className="absolute top-20 right-8 sm:right-16 w-2 h-2 sm:w-3 sm:h-3 bg-white opacity-25 rounded-full animate-pulse"
          style={{ animationDelay: "3s" }}
        ></div>
      </div>
    </section>
  );
};

const AnimatedButton = ({ format, delay, isConvertImage }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isAnimated, setIsAnimated] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsAnimated(true), delay);
    return () => clearTimeout(timer);
  }, [delay]);

  // If it's the convert image, render the image instead of a button
  if (isConvertImage) {
    return (
      <div
        className={`
          relative overflow-hidden group
          transition-all duration-500 ease-out transform
          ${
            isAnimated
              ? "translate-y-0 opacity-100 scale-100"
              : "translate-y-4 opacity-0 scale-95"
          }
          cursor-default select-none
          hover:scale-110
        `}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          transitionDelay: isAnimated ? "0ms" : `${delay}ms`,
        }}
      >
        <img
          src={cb}
          alt="Convert Button"
          className={`
            w-[4rem] h-12 sm:w-[5rem] sm:h-16 md:w-[9rem] md:h-20 lg:w-[12rem] lg:h-[6rem] xl:w-[13rem] xl:h-[7rem]
            transition-all duration-300 transform
            
          `}
        />

        {/* Floating Animation */}
        <div
          className={`
          absolute inset-0 
          ${isHovered ? "animate-float" : ""}
        `}
        ></div>
      </div>
    );
  }

  return (
    <div
      className={`
        relative overflow-hidden group
        text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl font-semibold
        px-3 py-1.5 sm:px-4 sm:py-2 md:px-6 md:py-2.5 lg:px-8 lg:py-3 xl:px-12 xl:py-4
        rounded-full
        transition-all duration-500 ease-out transform
        ${
          isAnimated
            ? "translate-y-0 opacity-100 scale-100"
            : "translate-y-4 opacity-0 scale-95"
        }
        bg-white text-green-700 hover:bg-green-50 hover:scale-105 shadow-md hover:shadow-lg hover:shadow-green-200/50
        cursor-default select-none
        min-w-max
      `}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        transitionDelay: isAnimated ? "0ms" : `${delay}ms`,
      }}
    >
      {/* Ripple Effect */}
      <div
        className={`
        absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent opacity-0
        ${isHovered ? "animate-pulse opacity-20" : ""}
        transition-opacity duration-300 rounded-full
      `}
      ></div>

      {/* Button Content */}
      <span className="relative z-10 tracking-wide flex items-center justify-center whitespace-nowrap">
        {format}
      </span>

      {/* Shine Effect for regular buttons */}
      <div
        className={`
        absolute top-0 left-0 w-full h-full
        bg-gradient-to-r from-transparent via-white to-transparent
        opacity-0 transform -skew-x-12 -translate-x-full rounded-full
        ${isHovered ? "animate-shine" : ""}
      `}
      ></div>

      {/* Hover Glow for regular buttons */}
      <div
        className={`
        absolute inset-0 bg-green-100 opacity-0 rounded-full
        ${isHovered ? "opacity-30" : ""}
        transition-opacity duration-300
      `}
      ></div>
    </div>
  );
};

// Enhanced CSS animations
const styles = `
  @keyframes shine {
    0% { transform: translateX(-100%) skewX(-12deg); opacity: 0; }
    50% { opacity: 0.15; }
    100% { transform: translateX(200%) skewX(-12deg); opacity: 0; }
  }
  
  .animate-shine {
    animation: shine 1.2s ease-in-out;
  }
  
  @keyframes float {
    0%, 100% { transform: translateY(0px) rotate(0deg); }
    50% { transform: translateY(-8px) rotate(2deg); }
  }
  
  .animate-float {
    animation: float 4s ease-in-out infinite;
  }

  @keyframes gentleBounce {
    0%, 100% { transform: translateY(0px); }
    50% { transform: translateY(-3px); }
  }

  .animate-gentle-bounce {
    animation: gentleBounce 2s ease-in-out infinite;
  }

  /* Custom responsive utilities */
  @media (max-width: 640px) {
    .container {
      padding-left: 1rem;
      padding-right: 1rem;
    }
  }

  @media ( max-width :360px){
  .hari_class{
   font-size:0.55rem;
   gap-[5px]
  }
   .size-decre{
   padding :0px !important}
    .green{
    gap :5px !important }
  }
`;

// Inject styles
if (typeof document !== "undefined") {
  const existingStyle = document.getElementById("formats-animation-styles");
  if (existingStyle) {
    existingStyle.remove();
  }

  const styleElement = document.createElement("style");
  styleElement.id = "formats-animation-styles";
  styleElement.textContent = styles;
  document.head.appendChild(styleElement);
}

export default ResponsiveFormatsSection;
